import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { format } from "date-fns";

type CloneEventDialogContentProps = {
  confirmationText: string;
  startDate: Date;
  isDifferentStaffMember: boolean;
  isDifferentClinic: boolean;
  newStaffMemberFullName: string;
  newClinicName: string;
};

export default function CloneEventDialogContent({
  confirmationText,
  startDate,
  isDifferentStaffMember,
  isDifferentClinic,
  newStaffMemberFullName,
  newClinicName,
}: CloneEventDialogContentProps) {
  return (
    <Stack gap="6px">
      <Typography
        variant="body2"
        fontSize="20px"
        lineHeight="28px"
        marginBottom="6px"
      >
        {confirmationText}
      </Typography>
      <Stack direction="row">
        <Typography
          variant="body2"
          fontSize="20px"
          width="28px"
          lineHeight="28px"
        >
          To
        </Typography>
        <Stack sx={{ ml: "8px" }} gap={0.5}>
          <Typography
            component="span"
            variant="body2"
            fontSize="18px"
            fontWeight={700}
            lineHeight="28px"
          >
            {format(startDate, "EEE MMM dd, yyyy hh:mm aaa")}
          </Typography>
          {isDifferentStaffMember && (
            <Typography
              component="span"
              variant="body3"
              lineHeight="20px"
              fontSize="16px"
              fontWeight={700}
            >
              {newStaffMemberFullName}
            </Typography>
          )}
          {isDifferentClinic && (
            <Typography
              component="span"
              variant="body3"
              lineHeight="20px"
              fontSize="16px"
              fontWeight={700}
            >
              {newClinicName}
            </Typography>
          )}
        </Stack>
      </Stack>
    </Stack>
  );
}
